// Centralized gallery data
import { menuImages } from './menu';

export const galleryImages = [
  { id: 'gal-mix-grill', src: menuImages.mixGrill, alt: 'Mix Grill Plate' },
  { id: 'gal-qouzi', src: menuImages.qouziLamb, alt: 'Qouzi Lamb Over Rice' },
  { id: 'gal-chicken-kebab', src: menuImages.chickenKebab, alt: 'Chicken Kebab Plate' },
  { id: 'gal-shawarma', src: menuImages.iraqiBeefShawarma, alt: 'Iraqi Beef Shawarma' },
  { id: 'gal-shawarma-saj', src: menuImages.chickenShawarmaSaj, alt: 'Chicken Shawarma Saj' },
  { id: 'gal-falafel', src: menuImages.falafelMix, alt: 'Falafel Mix Plate' },
  { id: 'gal-hummus', src: menuImages.hummus, alt: 'Hummus' },
  { id: 'gal-fattoush', src: menuImages.fattoush, alt: 'Fattoush Salad' },
  { id: 'gal-chicken', src: menuImages.grilledChicken, alt: 'Grilled Chicken' },
  { id: 'gal-copper-grill', src: '/photos/IMG_0933.jpg', alt: 'Mixed Grill on Copper Tray' },
  { id: 'gal-whole-chicken', src: '/photos/IMG_0935.jpg', alt: 'Whole Roasted Chicken Platter' },
  { id: 'gal-beef-tikka', src: '/photos/IMG_0942.jpg', alt: 'Beef Tikka with Saffron Rice' },
  { id: 'gal-masgouf', src: '/photos/IMG_0948.jpg', alt: 'Grilled Fish Masgouf' },
  { id: 'gal-fish-platter', src: '/photos/IMG_0950.jpg', alt: 'Whole Fish Platter' },
  { id: 'gal-babaganoush', src: '/photos/IMG_0952.jpg', alt: 'Babaganoush with Pomegranate' },
  { id: 'gal-dip', src: '/photos/IMG_0956.jpg', alt: 'Traditional Dip' },
  { id: 'gal-tabbouleh', src: '/photos/IMG_0963.jpg', alt: 'Fresh Tabbouleh Salad' },
  { id: 'gal-fattoush2', src: '/photos/IMG_0973.jpg', alt: 'Fattoush with Crispy Pita' },
  { id: 'gal-chef-sam', src: '/photos/IMG_0986.jpg', alt: 'Chef Sam with Whole Lamb' },
  { id: 'gal-iraqi-fish', src: '/photos/IMG_1142.jpg', alt: 'Iraqi Grilled Fish' },
  { id: 'gal-mosaic-dip', src: '/photos/IMG_1926.jpg', alt: 'Babaganoush on Mosaic Table' },
];
